import React from "react";

interface ExternalLinkProps {
    href: string;
    children: React.ReactNode;
    className?: string;
}

const ExternalLink = ({ href, children, className }: ExternalLinkProps) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`link-primary text-decoration-underline ${className ?? ""}`}
    >
        {children}
    </a>
);

export default ExternalLink;
